import { createTheme, ThemeProvider } from '@mui/material';
import React from 'react';




export default function Theme({ children }) {

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}



const theme = createTheme({
  components: {
    MuiTypography: {
      defaultProps: {
        fontFamily: '"PT Sans Narrow",sans-serif',
      }
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: "#2abdff",
          color: 'white',
          fontFamily: '"PT Sans Narrow",sans-serif;',
          fontWeight: 700,
          ":hover": {
            backgroundColor: "#2abdff",

          }
        }
      },
      defaultProps: {
        variant: 'contained'
      }
    }
  }
})